<script>
	import ModalForSortListAndSmile from '../ModalForComments/ModalForSortListAndSmile.svelte';
  
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import { clickOutside } from '../../../../../helpers';

  export let comments;
  export let sortItem;

  const dispatch = createEventDispatcher();

  let showSort = false;

  const sortList = [
    { name_ru: $_("OldComment"), name_en: "created_at" },
    { name_ru: $_("NewComment"), name_en: "-created_at" },
    { name_ru: $_("InterestingComment"), name_en: "-like_count" },
  ];

  $: nameButton = () => {
    const values = {
      '': $_("OldComment"),
      'created_at': $_("OldComment"),
      '-created_at': $_("NewComment"),
      '-like_count': $_("InterestingComment"),
    }

    return values[sortItem];
  }

  const selectAnOption = (sort) => {
    showSort = !showSort;

    dispatch('change-sort', { sort });

    localStorage.setItem('sortComments', sort);
  }
</script>

<div 
  class="sort-panel"
  use:clickOutside 
  on:click_outside={() => showSort = false} 
>
  {#if comments.length && comments.length >= 2}
    <button 
      class="sort" 
      on:click={() => showSort = !showSort} 
    >
      <span class="sort_text">{nameButton()}</span>
      <i class={showSort ? 'icon-chevron-up' : 'icon-chevron-down'}/>
    </button>

  {#if showSort}
    <ModalForSortListAndSmile>
      <div 
        class="main_filter"
        use:clickOutside 
	      on:click_outside={() => showSort = false} 
      >
        <div class="filter">
          {#each sortList as sort}
            <span 
              class="filter_label"
              on:click={() => selectAnOption(sort.name_en)}
            >
              {sort.name_ru}
            </span>
          {/each}
        </div>
      </ModalForSortListAndSmile>
    {/if}
  {/if}
</div>

<style>
  .sort-panel {
    display: inline-block;
    margin-top: 20px;
    width: 190px;
  }

  .icon-chevron-down,
  .icon-chevron-up {
    font-size: 7px;
  }

  .filter_label {
    padding-bottom: 9px;
    cursor: pointer;
    font-size: 16px;
    line-height: 23px;
  }

  .main_filter {
    position: absolute;
    animation: ani 0.2s forwards;
    z-index: 999;
  }
  
  .filter {
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    box-shadow: 0px 2px 10px rgba(48, 51, 61, 0.26);
    border-radius: 10px;
    background: white;
  }

  /* кнопка и список для сортировки комментов */
  .sort {
    width: 190px;
    margin-bottom: 10px;
    background: #576ced;
    border-radius: 30px;
    color: #ffffff;
    border: none;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 20px;
  }
  .sort_text {
    padding-right: 9px;
  }
</style>